





















import { Component, Prop, Mixins } from 'vue-property-decorator';
import DateMethods from '@/mixins/DateMethods.vue';

@Component
export default class CalendarBookingList extends Mixins(DateMethods) {
    @Prop() public feedItemData!: any;

    constructor() {
        super();
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get dataLoaded() {
        return (this.feedItemData !== null);
    }

    public viewHandler() {
        this.$router.push({
            name: 'shared-facilities',
            params: {
                bookingId: this.feedItemData.id.toString(),
            },
            query: {
                bookingId: this.feedItemData.id.toString(),
            },
        });
    }
}
